export default __webpack_public_path__ + "static/media/AncientRuins.9bb24698.jpg";